import { getTimeline } from './timeline_selectors.js'
import { pickBy, includes } from 'lodash-es'

export function getMarkers(state, props) {
  return state.data.markers
}

export function getMarker(state, props, id) {
  const idString = id.toString()
  return getMarkers(state, props)[idString]
}

export function getMarkersForTimeline(state, props, timelineId) {
  const timeline = getTimeline(state, props, timelineId)
  const markerIds = timeline.marker_ids
  const allMarkers = getMarkers(state, props) || {}
  const filtered = pickBy(allMarkers, marker => includes(markerIds, marker.id))
  return filtered
}
